import { HttpClientPlugin } from '../types';
import { getGlueUrl } from '@/src/lib/glue/url';

export function createWithGlueUrlPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      return { url: getGlueUrl(url), options };
    },
  };
}
